import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function Art() {
  const artDirections = [{
    title: 'Expressive',
    category: 'Abstract & Emotional',
    description: 'Bold works exploring color, texture, and emotion through forms and materials',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hKjmUDvbCZ3JrSUCgzjGz3/image.png',
    color: 'from-cyan-100 to-blue-100',
    link: '/projects/expressive'
  }, {
    title: 'Academic',
    category: 'Classical Techniques',
    description: 'Traditional studies in watercolor, oil, and mixed media, honoring classical approaches',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6X7aD6NheTJr6ATxWmaYrR/image.png',
    color: 'from-stone-100 to-cyan-100',
    link: '/projects/academic'
  }, {
    title: 'Commission',
    category: 'Custom Artwork',
    description: 'Bespoke pieces created for clients, blending personal vision with client requests',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t2YnexkjxVmbKVn8n1vCXK/image.png',
    color: 'from-emerald-100 to-teal-100',
    link: '/projects/commission'
  }, {
    title: 'Sketching',
    category: 'Observational Drawing',
    description: 'Architectural, observational and imagination sketches, practicing technique',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/arCbBS8xnrk7yHQKS43Ckb/image.png',
    color: 'from-stone-100 to-stone-200',
    link: '/projects/sketching'
  }];
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-457">
      {/* Header */}
      <header className="py-8 px-6 bg-white border-b border-stone-200" data-id="element-458">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-459">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-460">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-461" />
            <span className="font-light" data-id="element-462">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-463">Maria Elina</h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-464">
        <div className="max-w-7xl mx-auto text-center" data-id="element-465">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-466">
            <div className="text-6xl mb-6" data-id="element-467">🎨</div>
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-6" data-id="element-468">
              Art
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-469">
              Visual expression and commissions focused on the human experience
            </p>
          </motion.div>
        </div>
      </section>
      {/* Art Directions Grid */}
      <section className="py-20 px-6" data-id="element-470">
        <div className="max-w-7xl mx-auto" data-id="element-471">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-472">
            {artDirections.map((direction, index) => <motion.div key={direction.title} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} whileHover={{
            y: -10
          }} className="group" data-id="element-473">
                {direction.link ? <Link to={direction.link} data-id="element-474">
                    <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-475">
                      <motion.img src={direction.image} alt={direction.title} className="w-full h-full object-cover" whileHover={{
                  scale: 1.05
                }} transition={{
                  duration: 0.6
                }} data-id="element-476" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${direction.color} opacity-0 group-hover:opacity-40 transition-opacity duration-500`} data-id="element-477" />
                    </div>
                    <div className="space-y-2" data-id="element-478">
                      <p className="text-sm text-emerald-700 font-light tracking-wide uppercase" data-id="element-479">
                        {direction.category}
                      </p>
                      <h3 className="text-2xl font-light text-stone-900 group-hover:text-emerald-800 transition-colors" data-id="element-480">
                        {direction.title}
                      </h3>
                      <p className="text-stone-600 font-light leading-relaxed" data-id="element-481">
                        {direction.description}
                      </p>
                    </div>
                  </Link> : <>
                    <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-482">
                      <motion.img src={direction.image} alt={direction.title} className="w-full h-full object-cover opacity-60" whileHover={{
                  scale: 1.05
                }} transition={{
                  duration: 0.6
                }} data-id="element-483" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${direction.color} opacity-40`} data-id="element-484" />
                    </div>
                    <div className="space-y-2" data-id="element-485">
                      <p className="text-sm text-emerald-700 font-light tracking-wide uppercase" data-id="element-486">
                        {direction.category}
                      </p>
                      <h3 className="text-2xl font-light text-stone-900" data-id="element-487">
                        {direction.title}
                      </h3>
                      <p className="text-stone-600 font-light leading-relaxed" data-id="element-488">
                        {direction.description}
                      </p>
                    </div>
                  </>}
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-489">
        <div className="max-w-4xl mx-auto text-center" data-id="element-490">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-491">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-492">
              Interested in collaborating?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-493">
              Let's create something meaningful together
            </p>
            <motion.a href="mailto:contact@maria-elina.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-494">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-495" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-496">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-497" />
                <span className="text-lg font-light relative z-10" data-id="element-498">
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}